import React, { useState } from 'react';
import FAQItem from './FAQItem';
import { useSiteContent } from '../contexts/SiteContentContext';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState(null);
  const faqs = useSiteContent().content.faq;

  const toggleFaq = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="page-container">
      <header className="page-header">
        <div className="header-content">
          <h1>Frequently asked questions</h1>
          <p className="header-subtitle">Strategies, playbooks, odds and parlays, explained.</p>
        </div>
      </header>
      <div className="faq-list">
        {faqs.map((faq, index) => (
          <FAQItem
            key={index}
            question={faq.question}
            answer={faq.answer}
            isOpen={openIndex === index}
            onClick={() => toggleFaq(index)}
          />
        ))}
      </div>
    </div>
  );
}
